<template>
  <div class="smaller-container-wrapper full-height">
    <MobialisFormWithValidation
      @onValidate="submit"
      novalidate
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
      data-test="form"
    >
      <h2 class="mb-3 mb-sm-4">{{ $t('message.eCommerceV2.finance.employmentDetailsForm.heading') }}</h2>
      <mobialis-text-input-with-validation
        rules="required"
        :label="$t('message.eCommerceV2.finance.employmentDetailsForm.employerName')"
        v-model="employerName"
        vid="employerName"
        :helper="$t('message.eCommerceV2.finance.employmentDetailsForm.employerNameHelper')"
        data-cy="employerName"
      ></mobialis-text-input-with-validation>
      <mobialis-text-input-with-validation
        rules="required"
        :label="$t('message.eCommerceV2.finance.employmentDetailsForm.currentOccupation')"
        v-model="currentOccupation"
        vid="currentOccupation"
        id="currentOccupation"
        data-cy="currentOccupation"
      ></mobialis-text-input-with-validation>
      <mobialis-text-input-with-validation
        class="input-width-100"
        rules="required|min_value:1|max_value:99"
        :label="$t('message.eCommerceV2.finance.employmentDetailsForm.yearsWorked')"
        v-model="yearsWorked"
        vid="yearsWorked"
        mask-type="naturalNumbers"
        inputmode="numeric"
        pattern="[0-9]*"
        data-cy="yearsWorked"
        data-test="employmentYearsWorked"
      ></mobialis-text-input-with-validation>
      <div class="push-down-desktop">
        <mobialis-button type="submit" class="mt-5 mb-3" data-cy="continue">{{
          $t('message.common.continue')
        }}</mobialis-button>
      </div>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { enumMixin } from '@/mixins';

export default {
  name: 'EmploymentStatusForm',
  mixins: [enumMixin],
  data() {
    return {
      employerName: cloneDeep(this.$store.state.user.financeApplication.employerName),
      currentOccupation: cloneDeep(this.$store.state.user.financeApplication.currentOccupation),
      yearsWorked: cloneDeep(this.$store.state.user.financeApplication.yearsWorked),
    };
  },
  methods: {
    submit(isValid) {
      if (!isValid) {
        return;
      }
      this.$store.commit('user/SET_EMPLOYER_NAME', this.employerName);
      this.$store.commit('user/SET_CURRENT_OCCUPATION', this.currentOccupation);
      this.$store.commit('user/SET_YEARS_WORKED', this.yearsWorked);
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss" scoped></style>
